import { useMemo } from 'react';
import { LOCATION_SETTING_OPERATOR_ROLES, useLocationSetting } from './useLocationSetting';

export const useForceStoragePassthroughForLocation = () => {
  const { value, setValue, isLoading, canUpdate } = useLocationSetting<boolean>('force_storage_passthrough', false, {
    roles: LOCATION_SETTING_OPERATOR_ROLES,
  });

  return useMemo(
    () => ({
      forceStoragePassthroughForLocation: value,
      setForceStoragePassthroughForLocation: setValue,
      isLoading,
      canUpdate,
    }),
    [value, setValue, isLoading, canUpdate],
  );
};
